import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/Navbar/Navbar";
import MobileBottomNav from "./components/MobileBottomNav/MobileBottomNav";
import HomeScreen from "./screen/HomeScreen";
import ErrorScreen from "./screen/ErrorScreen";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import Cart from "./screen/Cart";
import MenuCardScreen from "./screen/MenuCardScreen";
import Connect from "./screen/Connect";
import { setupCartCleanup } from "./utils/cartCleanup";

const theme = createTheme({
  typography: {
    fontFamily: "'Roboto', sans-serif",
  },
  shape: {
    borderRadius: 12,
  },
});
function App() {
  // console.log({logged});

  // Set up cart cleanup on app start
  useEffect(() => {
    setupCartCleanup();
  }, []);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider
        theme={theme}
      >
        <CssBaseline />
        <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/orders" element={<Cart />} />
            <Route path="/MenuCardScreen" element={<MenuCardScreen />} />
            <Route path="/connect" element={<Connect />} />
            <Route path="*" element={<ErrorScreen />} />
          </Routes>
          <MobileBottomNav />
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
